import { Fragment } from "react";

// Tiny, safe markdown-ish renderer for Content docs: #/## headings, - bullets, 1. lists, **bold**, blank-line paragraphs.
function inline(text) {
  return text.split(/(\*\*[^*]+\*\*)/g).map((part, i) =>
    part.startsWith("**") && part.endsWith("**") ? <strong key={i} className="font-semibold text-foreground">{part.slice(2, -2)}</strong> : <Fragment key={i}>{part}</Fragment>);
}

function Block({ block }) {
  const lines = block.split("\n");
  if (lines.every((l) => /^\s*[-*]\s+/.test(l))) {
    return <ul className="list-disc space-y-2 pl-5">{lines.map((l, i) => <li key={i}>{inline(l.replace(/^\s*[-*]\s+/, ""))}</li>)}</ul>;
  }
  if (lines.every((l) => /^\s*\d+[.)]\s+/.test(l))) {
    return <ol className="list-decimal space-y-2 pl-5">{lines.map((l, i) => <li key={i}>{inline(l.replace(/^\s*\d+[.)]\s+/, ""))}</li>)}</ol>;
  }
  if (lines[0].startsWith("## ")) return <h3 className="pt-2 text-lg font-semibold text-foreground">{inline(lines[0].slice(3))}</h3>;
  if (lines[0].startsWith("# ")) return <h2 className="pt-4 text-xl font-semibold text-foreground">{inline(lines[0].slice(2))}</h2>;
  return <p className="whitespace-pre-line">{inline(block)}</p>;
}

export default function ContentBody({ body, testId = "content-body" }) {
  const blocks = String(body || "").split(/\n\s*\n/).map((b) => b.trim()).filter(Boolean);
  return (
    <div className="cw-soft space-y-5 text-base leading-7" data-testid={testId} data-no-i18n>
      {blocks.map((b, i) => <Block key={i} block={b} />)}
    </div>
  );
}
